// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"HtmlArtifactFrame-primaryButton-wHWKul","frame":"HtmlArtifactFrame-frame-1FVGU1","pending":"HtmlArtifactFrame-pending-3rCAwf"};